export const Accordion = {
  baseStyle: {
    container: {
      borderWidth: '0px',
      marginTop: '0px',
      marginBottom: '8px',
      _last: {
        borderBottomWidth: 0,
      },
    },
    panel: {
      padding: '0 16px 16px',
      minHeight: '120px',
      bg: 'neutral.50',
      borderBottomRadius: '16px',
      borderWidth: '1px',
      borderTopWidth: '0px',
      borderColor: 'neutral.300',
      transition: 'height 1s ease-out, opacity 0.3s ease-out',
    },
    button: {
      color: '#1e1e1e',
      padding: '16px',
      bg: 'neutral.50',
      borderRadius: '16px',
      borderWidth: '1px',
      borderColor: 'neutral.300',
      marginBottom: '0px',
      height: '58px',
      _expanded: {
        borderBottomWidth: '0px',
        borderBottomRadius: '0px',
      },
      _hover: {
        bg: 'neutral.50',
        borderColor: 'neutral.300',
      },
    },
  },
};
